import React from "react";
import LockScreenForm from "../../components/Auth/LockScreenForm";
import AuthBackgroundSlideshow from "../../components/AuthBackground/Slideshow";

const LockScreen = () => {
  return (
    <>
      {/* Animated Background Slideshow */}
      <AuthBackgroundSlideshow />
      <LockScreenForm />
    </>
  );
};

export default LockScreen;
